import getPDFScrollableDOMElement from '@app/libs/reactPdfJs/utils/getPDFScrollableDOMElement';

export default class Position {
  static offset(element) {
    const { scrollTop } = getPDFScrollableDOMElement();
    const elementRect = element.getBoundingClientRect();

    return {
      top: elementRect.top + scrollTop,
      left: elementRect.left,
    };
  }
}
